module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalplaymultiplayers",
    attrs: {
      "id": "modalplaymultiplayers",
      "title": "Jeu multijoueurs",
      "hide-footer": true
    }
  }, [_c('b-card', {
    staticClass: "shadow-sm mb-3 bt-white rounded",
    attrs: {
      "title": "Multi-joueurs temps réel",
      "img-src": require('@/assets/images/play-multiplayers.jpg'),
      "img-alt": "Jeu multijoueurs",
      "img-top": ""
    }
  }, [_c('b-card-text', {
    staticClass: "text-left"
  }, [_vm._v("\n      Jouez en temps réel sur le même ordinateur / téléphone / tablette ou chacun le vôtre. "), _c('br'), _vm._v("\n      Piochez un mot et faites-le deviner aux autres grâce aux images "), _c('i', [_vm._v("Concept")]), _vm._v("."), _c('br'), _vm._v("\n      Deux modes de jeu sont possibles :\n      "), _c('ul', [_c('li', [_vm._v("Vous pouvez jouer sur le même ordinateur / tablette / smartphone mais "), _c('strong', [_vm._v(" attention, pensez bien à masquer l'écran lorsque vous lancez le jeu car les mots vont apparaître à l'écran")]), _vm._v(". Puis faites deviner aux autres joueurs une fois que vous connaissez le mot et que vous faites deviner.")]), _vm._v(" "), _c('li', [_vm._v("Chacun sur son ordinateur / tablette / smartphone en créant ou en rejoignant une partie existante.")])])]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.words",
      modifiers: {
        "words": true
      }
    }],
    staticClass: "m-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.launchPlaySameDevice()
      }
    }
  }, [_vm._v("Sur le même ordi "), _c('font-awesome-icon', {
    attrs: {
      "icon": "clock"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.launchMultiplayers()
      }
    }
  }, [_vm._v("Créer une partie "), _c('font-awesome-icon', {
    attrs: {
      "icon": "puzzle-piece"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd12659","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-play-multiplayers.vue
// module id = Ws68
// module chunks = 1